// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".style__monitoringOverview___3893H{font-size:70%;margin-bottom:25px}.style__monitoringOverview___3893H .style__right___20No6{text-align:right}.style__monitoringOverview___3893H .style__center___2HWQl{text-align:center}\n", "",{"version":3,"sources":["webpack://./src/health/alerting/style.scss"],"names":[],"mappings":"AAAA,mCACE,aAAc,CACd,kBAAmB,CAFrB,yDAII,gBAAiB,CAJrB,0DAQI,iBAAkB","sourcesContent":[".monitoringOverview {\n  font-size: 70%;\n  margin-bottom: 25px;\n  .right {\n    text-align: right;\n  }\n\n  .center {\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"monitoringOverview": "style__monitoringOverview___3893H",
	"right": "style__right___20No6",
	"center": "style__center___2HWQl"
};
export default ___CSS_LOADER_EXPORT___;
